export default __webpack_public_path__ + "static/media/01.015e9c63.jpg";